<script setup lang="ts">

defineProps<{
    label: string;
    error?: string;
    hint?:string;
    labelFor?: string;
    required?: boolean
}>();

</script>

<template>
    <VLIftaLabel>
        <slot />
        <label :for="labelFor">
            {{ label }}
            <span v-if="required" class="text-[var(--danger-color)]">*</span>
        </label>
        <VLMessage v-if="error" severity="error" size="small" variant="simple" class="ml-1 mt-1">
            {{ error }}
        </VLMessage>

        <VLMessage v-if="hint && !error" severity="primary" size="small" variant="simple" class="ml-1 mt-1">
            {{ hint }}
        </VLMessage>
    </VLIftaLabel>
</template>
